<template>
  <div class="wrap">
    <div class="zxt" :style="zxtStyle"></div>
    <div class="yxy" :style="yxyStyle"></div>
    <div class="loveDay" :style="loveDayStyle"></div>
    <el-form :model="formLogin" ref="ruleForm" label-width="0px" class="login-bok">
      <div style="text-align:center">
        <img src="https://img.codesocean.top/image/1666771338457"
          style="width: 80%;margin-top: 30px;margin-bottom: 30px;">
      </div>
      <el-form-item prop="username" style="margin-left: 15px;margin-right: 15px;">
        <el-input v-model="formLogin.user_id" placeholder="账号" @focus="yourBirthDay()">
          <i slot="prepend" class="el-icon-user" />
        </el-input>
      </el-form-item>
      <el-form-item prop="password" style="margin-left: 15px;margin-right: 15px;">
        <el-input type="password" placeholder="密码" v-model="formLogin.user_pwd" @focus="TaBirthDay()" show-password>
          <i slot="prepend" class="el-icon-lock" />
        </el-input>
      </el-form-item>
      <el-form-item prop="password" style="margin-left: 15px;margin-right: 15px;">
        <el-input placeholder="在一起的日子" v-model="formLogin.loveDay" @focus="loveDay()">
          <i slot="prepend" class="el-icon-date" />
        </el-input>
      </el-form-item>
      <el-form-item>
        <div class="login-btn">
          <el-button type="primary" @click="login()"
            style="margin-left: 28%;width: 40%;position: absolute;top: 0;font-size: 16px;margin-bottom: 50px !important;"
            round>登陆</el-button>
          <span style="user-select: none;">&nbsp;</span>
        </div>
      </el-form-item>
      <el-form-item>
        <div class="login-btn">
          <el-button type="primary" @click="visitorLogin()"
            style="margin-left: 28%;width: 40%;position: absolute;top: 0;font-size: 16px;margin-bottom: 50px !important;"
            round>游客请点这里</el-button>
          <span style="user-select: none;">&nbsp;</span>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

export default {
  name: "login",
  mounted() {
    this.$message({
      message: '欢迎来到我们的小网站',
      type: 'success'
    })
  },
  data() {
    return {
      zxtStyle: '\
          bottom:0;\
          width: 30vw;\
          height: 30vw;\
          // background-color:#bfa;\
          float:left;\
          position:absolute;\
          left:-30vw;\
          transition:1000ms;\
          ',
      zxtStyleAct: '\
          bottom:0;\
          width: 30vw;\
          height: 30vw;\
          // background-color:#bfa;\
          float:left;\
          position:absolute;\
          left:-30vw;\
          transition:1000ms;\
          transform:translateX(30vw);\
          ',
      yxyStyle: '\
          bottom:0;\
          width: 30vw;\
          height: 30vw;\
          // background-color:#bfa;\
          float:right;\
          position:absolute;\
          right:-30vw;\
          transition:1000ms;\
          ',
      yxyStyleAct: '\
          bottom:0;\
          width: 30vw;\
          height: 30vw;\
          // background-color:#bfa;\
          float:right;\
          position:absolute;\
          right:-30vw;\
          transition:1000ms;\
          transform:translateX(-30vw);\
          ',
      loveDayStyle: '\
          top:-20vh;\
          width: 100vw;\
          height: 20vh;\
          // background-color:#bfa;\
          float:left;\
          position:absolute;\
          transition:1000ms;\
          ',
      loveDayStyleAct: '\
          top:-20vh;\
          width: 100vw;\
          height: 20vh;\
          // background-color:#bfa;\
          float:left;\
          position:absolute;\
          transition:1000ms;\
          transform:translateY(20vh);\
          ',
      formLogin: {
        user_id: '',
        user_pwd: '',
        loveDay: '',
      },


    }
  },
  props: {
    defaultMsg: {
      type: String
    },
    config: {
      type: Object
    }
  },
  created() {

  },
  mounted() {
    
  },

  methods: {
    yourBirthDay() {
      this.zxtStyle = this.zxtStyleAct
    },
    TaBirthDay() {
      this.yxyStyle = this.yxyStyleAct
    },
    loveDay() {
      this.loveDayStyle = this.loveDayStyleAct
    },
    visitorLogin() {

      this.$userInfo.$userLimit = '3';
      this.$userInfo.$userName = '游客';
      this.$router.push('/home');
      that.$message({
        message: '欢迎回来',
        type: 'success'
      });

    },
    login() {
      let that = this;
      if (this.formLogin.yourBirthDay === "" || this.formLogin.TaBirthDay === "" || this.formLogin.loveDay === "") {
        this.$message({
          message: '咋没输入完捏',
          type: 'warning'
        })
      } else if (this.formLogin.loveDay === '20181110') {
        let userId = that.formLogin.user_id;
        let userPwd = that.formLogin.user_pwd;
        this.$axios({
          method: 'get',
          url: this.$baseUrl + '/login/login?user_login_id=' + userId + "&user_pwd=" + userPwd,
        }).then((res) => {
          if (res.data.msg === "wrong pwd or login id") {
            that.$message({
              message: '用户名或密码错误',
              type: 'error'
            });
          } else if (res.data.msg === "no such user") {
            that.$message({
              message: '没有该用户',
              type: 'error'
            });
          } else {
            let name = res.data.data.user_name;
            let limit = res.data.data.user_limit;

            that.$userInfo.$userName = name;
            that.$userInfo.$userLimit = limit;
            console.log("输出");
            console.log(that.$userInfo.$userLimit);
            that.$router.push('/home');
          }
        }).catch((err) => {

        });
      } else {
        this.$message({
          message: '第三项错啦！',
          type: 'error'
        })
      }
    }
  },

}
</script>

<style scoped lang="scss">
.zxt {
  background: url("https://img.codesocean.top/image/1666771471946") fixed center center;
  background-size: 30vw 30vw;
}

.yxy {
  background: url("https://img.codesocean.top/image/1666771414423") fixed center center;
  background-size: 30vw 30vw;
}

.loveDay {
  background: url("https://img.codesocean.top/image/1666771412164") fixed center center;
  background-size: 100vw auto;
}

.wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: url('') fixed center center;
  background-size: 100% 100%;

  .logo {
    display: inline-block;
    position: absolute;
    width: 125px;
  }

}

.login-bok {
  height: auto;
  width: 25%;
  margin: 30vh auto;
  border: 1px solid #DCDFE6;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 30px #DCDFE6;
  background-color: #efefef55;
}

.ForgetPwd {
  cursor: pointer;
  color: white;
  margin-left: 75%;
  width: 15%;
  display: inline;
  float: left;
  font-size: 13px;
  margin-top: 5px;
}

.ForgetPwd:active {
  color: #efefef;
}

.ForgetPwd:hover {
  color: #efefef;
}

.resetPassword {
  height: 300px;
}

// .login-btn {
//   .el-button {
//     background-color: #e82032;
//     border: 1px solid #e82032;
//   }

//   .el-button:hover {
//     background-color: #ec4352;

//     border: 1px solid #ec4352;
//   }
// }

// /deep/ .el-input__inner:focus {
//   border: 1px solid #ffb0b7;
// }

::-webkit-scrollbar {
  display: none;
}
</style>
